import api from "./api";

// 文件夹删除
export const sidebarFolderDelete = async (folderId: string) => {
  const res = await api.post<unknown>("/sidebar/folder/delete", { folder_id: folderId });
  return res;
};
